import React, { useState } from "react";
import { useTranslation } from "react-i18next"; // Import the translation hook
import './ContactForm.css'; // Import the CSS file


function ContactForm() {
  const { t } = useTranslation(); 
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  return (
    <div className="container">
        <h2>{t("form.contactUs")}</h2> {/* Translated form title */}
        <form name="contact" method="POST" className="contact-form">
            <input type="hidden" name="form-name" value="contact"/>
            <input type="hidden" name="bot-field"/>

            <label htmlFor="name">{t("form.name")}</label>
            <input type="text" className="contact-form-input" id="name" name="name" placeholder={t("form.yourname")} value={name} onChange={(e)=> setName(e.target.value)}></input>
         
            <label htmlFor="email">{t("form.email")}</label>
            <input type="text" className="contact-form-input" id="email" name="email" placeholder={t("form.youremail")} value={email} onChange={(e)=> setEmail(e.target.value)}></input>
          
            <label htmlFor="message">{t("form.message")}</label>
            <textarea className="contact-form-textarea" name="message" id="message" placeholder={t("form.yourmessage")} value={message} onChange={(e)=> setMessage(e.target.value)}></textarea>
          
          <button type="submit" className="contact-form-button">{t("form.send")}</button>
        </form>
      </div>
  );
}

export default ContactForm;